'use strict';
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dComposite$002dKey$0024 from "./com.raquo.laminar.keys.-Composite-Key$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec(separator) {
  this.z3 = null;
  this.z3 = separator;
}
export { $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec as $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec };
$p = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec as $h_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec };
$h_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec.prototype = $p;
$p.OG = (function(domValue) {
  return $j_com$002eraquo$002elaminar$002ekeys$002e$002dComposite$002dKey$0024.$m_Lcom_raquo_laminar_keys_CompositeKey$().C8(domValue, this.z3);
});
$p.OM = (function(scalaValue) {
  return $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T(scalaValue, "", this.z3, "");
});
$p.kR = (function(domValue) {
  return this.OG(domValue);
});
$p.ie = (function(scalaValue) {
  return this.OM(scalaValue);
});
var $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec, "com.raquo.laminar.keys.CompositeKey$CompositeCodec", ({
  ig: 1,
  bb: 1
}));
export { $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec as $d_Lcom_raquo_laminar_keys_CompositeKey$CompositeCodec };
